"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Caption1Stronger: function() {
        return _Caption1Stronger.Caption1Stronger;
    },
    caption1StrongerClassNames: function() {
        return _useCaption1Strongerstyles.caption1StrongerClassNames;
    }
});
const _Caption1Stronger = require("./Caption1Stronger");
const _useCaption1Strongerstyles = require("./useCaption1Stronger.styles");
